<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2024.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2024-08-28                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-container>
    <b-row>
      <b-col sm="12" md="12" lg="6" xl="4" v-for="category_assignment in sorted_category_assignments" :key="category_assignment.id">
        <b-card>
          <b-card-title class="mb-3">
            {{category_assignment.title}}
          </b-card-title>
          <b-card-sub-title class="mb-3">
            {{category_assignment.subtitle}}
          </b-card-sub-title>
          <b-card-text>
            {{category_assignment.text}}
            <div v-if="bullets(category_assignment).length > 0">
              <ul class="mt-3">
                <li v-for="item in bullets(category_assignment)">{{item}}</li>
              </ul>
            </div>
          </b-card-text>
          <b-button variant="primary" v-on:click="selectBtoTemplate(category_assignment.cfg_template_id)">Configure</b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "product-category-bto-structure-list",
  props:{
    categoryAssignments:{
      type: Array,
      required: true
    }
  },
  computed:{
    sorted_category_assignments(){
      return this.categoryAssignments.sort((a, b) => {
        let aVal = a.sort_order;
        let bVal = b.sort_order;
        return ('' + aVal).localeCompare('' + bVal);
      });
    }
  },
  methods:{
    selectBtoTemplate(cfg_template_id){
      this.$router.push({
        name: 'configure_bto_path',  // Replace with your route's name
        params: { template_id: cfg_template_id } // Update this to your specific route param
      });
    },
    bullets(category_assignment){
      let result = [];
      if(!!category_assignment.bullets){
        const lines = category_assignment.bullets.split(/\r?\n/);
        result.push(...lines);
      }
      return result;
    }
  }
}
</script>

<style scoped>

</style>
